module.exports = __webpack_public_path__ + "media/images/icons/facebook-dc215b6cfb54c149c1b3e8fa9f0900f6.svg";